<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-auto">
        <h3 class="font-weight-bolder mt-2">Drug & Alcohol Test</h3>
      </div>
      <AddDrugAlcoholTest v-if="isDesignatedManning && !guest"></AddDrugAlcoholTest>
    </div>
    <div class="row">
      <div class="col-sm-12 text-small text-center">
        <table class="table table-hover table-bordered table-sm">
          <thead class="bg-lightgray">
          <tr>
            <th width="1%">#</th>
            <th width="10%">Test Date</th>
            <th width="9%">Test Result</th>
            <th width="13%">Tested By</th>
            <th>Remarks</th>
            <th width="5%">File</th>
            <th width="12%">Action</th>
          </tr>
          </thead>
          <tbody v-if="isDesignatedManning">
          <tr>
            <td>1</td>
            <td>05 SEP 2018</td>
            <td>NEGATIVE</td>
            <td>ELLIE CAMPBELL</td>
            <td>—</td>
            <td>3</td>
            <td>
              <button class="btn btn-outline-info btn-xs mr-1"
                      data-toggle="modal" data-target="">
                <i class="fas fa-eye"></i>
                View
              </button>
              <button class="btn btn-outline-danger btn-xs">
                <i class="fas fa-trash"></i>
                Delete
              </button>
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>23 AUG 2015</td>
            <td>NEGATIVE</td>
            <td>BRYAN CAMPBELL</td>
            <td>—</td>
            <td>2</td>
            <td>
              <button class="btn btn-outline-info btn-xs mr-1"
                      data-toggle="modal" data-target="">
                <i class="fas fa-eye"></i>
                View
              </button>
              <button class="btn btn-outline-danger btn-xs">
                <i class="fas fa-trash"></i>
                Delete
              </button>
            </td>
          </tr>
          <tr>
            <td>3</td>
            <td>16 OCT 2014</td>
            <td>NEGATIVE</td>
            <td>MICKEY BUTLER</td>
            <td>—</td>
            <td>4</td>
            <td>
              <button class="btn btn-outline-info btn-xs mr-1"
                      data-toggle="modal" data-target="">
                <i class="fas fa-eye"></i>
                View
              </button>
              <button class="btn btn-outline-danger btn-xs">
                <i class="fas fa-trash"></i>
                Delete
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import AddDrugAlcoholTest from '@/components/sub_components/master_lists/crews/crew_show_components/medical_issues/add/AddDrugAlcoholTest';
import { gateMixin} from "@/mixins/gateMixin";

export default {
  name: "DrugAlcoholTest",
    mixins: [ gateMixin ],
  components: {AddDrugAlcoholTest}
}
</script>

<style scoped>
.bg-lightgray {
  background: lightgray;
}
table td {
  vertical-align: middle;
}
</style>